<template>
  <div class="changePw">
    <h1>{{ locale.pw_change }}</h1>
    <h2 v-if="code === '201'">{{ locale.change_pw_desc }}<br>{{ locale.change_pw_security_policy }}</h2>
    <h2 v-if="code === '202'">{{ locale.change_pw_more_than }}<br>{{ locale.change_pw_desc }}</h2>
    <form @submit.prevent="change">
      <div class="formBox">
        <div class="formGroup mb30">
          <label class="label">{{ locale.current_pw }}</label>
          <input ref="oldPw" type="password" class="input" v-model="oldPw" @input="onInput">
          <p v-if="basicErrors.includes('empty_oldPw')" class="validationMessage">{{ locale.alert_change_pw_403_strOriPassword }}</p>
        </div>
        <div class="formGroup mb30">
          <label class="label">{{ locale.new_pw }}</label>
          <p class="rule">* {{ locale.change_pw_rule }}</p>
          <input ref="newPw" type="password" class="input" v-model="newPw" @input="onInput">
          <p v-if="basicErrors.includes('empty_newPw')" class="validationMessage">{{ locale.alert_change_pw_403_password }}</p>
          <!-- 비밀번호 유효성 검사 errors -->
          <ul v-if="inputErrors.length" class="validationMessage">
            <li v-for="(e, i) in inputErrors" :key="i">{{ locale[`invalid_pw_${e}`] }}</li>
          </ul>
        </div>
        <div class="formGroup mb30">
          <label class="label">{{ locale.new_pw_confirm }}</label>
          <input type="password" class="input" v-model="newPw2" @input="onInput">
          <p v-if="basicErrors.includes('not_match_newPw')" class="validationMessage">{{ locale.message_confirm_new_pw }}</p>
        </div>
        <div>
          <button type="submit" :disabled="!canSubmit" class="btn btnSubmit btnFull btnDark">{{ locale.do_change_pw }}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validatePassword, messages } from '@/common/validation_password'

export default {
  name: 'ChangePassword',
  props: {
    locale: Object,
    code: String
  },
  computed: {
    canSubmit () {
      // 필수값 + 모듈검사 OK + 새 비번 일치 + (선택) 이전 비번과 달라야 함
      return !!this.oldPw && !!this.newPw && this.newPw === this.newPw2 && this.ok && this.newPw !== this.oldPw
    }
  },
  created () {
    const userId = sessionStorage.getItem('tempUserId')
    if (!userId) {
      this.$router.replace('/')
      return
    }
    this.id = userId
  },
  mounted () {
    this.onInput()
    this.$nextTick(() => {
      if (this.$refs.oldPw) this.$refs.oldPw.focus()
    })
  },
  data() {
    return {
      id: '',
      oldPw: '',
      newPw: '',
      newPw2: '',
      basicErrors: [],
      inputErrors: [],
      ok: false,
      errors: []
    }
  },
  methods: {
    // 기본 폼 체크 (빈값/일치/이전비번 동일)
    basicValidation () {
      const errs = []
      if (!this.oldPw) errs.push('empty_oldPw')
      if (!this.newPw) errs.push('empty_newPw')
      if (this.newPw && this.newPw !== this.newPw2) errs.push('not_match_newPw')
      if (this.newPw && this.oldPw && this.newPw === this.oldPw) errs.push('same_oldPw')
      return errs
    },

    // 입력마다 모듈 유효성 갱신
    onInput () {
      const formErrs = this.basicValidation()

      let modErrs = []
      if (this.newPw) {
        const { ok, codes } = validatePassword(this.newPw, {
          userid: this.id
        })
        this.ok = ok
        if (!ok) modErrs = codes
      } else {
        this.ok = false
      }
      this.basicErrors = [...formErrs]
      this.inputErrors = [...modErrs]
    },

    async change () {
      // 최종 검증
      this.onInput()
      if (!this.canSubmit) return

      try {
        const data = {
          siteid: this.id.split('.')[1],
          id: this.id,
          oldPw: this.oldPw,
          newPw: this.newPw
        }
        const res = await this.$store.dispatch('authentication/changePassword', data)
        if (res?.status === 200) {
          const isLogined = this.$store.getters['authentication/getUserInfo']
          sessionStorage.removeItem('tempUserId')
          alert('비밀번호가 변경되었습니다.')
          if (isLogined) {
            if (window.history.length > 1) this.$router.go(-1)
            else this.$router.push('/')
          } else {
            await this.$store.dispatch('authentication/login', {
              uid: this.id,
              pw: this.newPw
            })
            this.$router.push('/')
          }
        } else {
          const code = res?.code || 403
          const message = `${code}${res?.reason ? '_' + res.reason.split(' ')[0] : ''}`
          /**
           * 301: 기존비밀번호 틀림
           * 302: 새비밀번호 유효하지않음
           * 403+strOriPassword: 기존비밀번호 입력필요
           * 403+password: 새비밀번호 입력필요
           */
          alert(this.locale[`alert_change_pw_${message}` || 'system_error'])
          if (message === '301' || message === '403_strOriPassword') {
            if (this.$refs.oldPw) this.$refs.oldPw.focus()
          }
          if (message === '302' || message === '403_password') {
            if (this.refs.newPw) this.$rfefs.newPw.focus()
          }
        }
      } catch (e) {
        // 서버 에러 메시지 매핑
        this.errors = [e?.message || '변경에 실패했습니다. 잠시 후 다시 시도해주세요.']
      } finally {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.changePw {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 30px;
  text-align: center;
  line-height: 1.3;
  overflow: auto;
}
.formBox {
  width: 100%;
  max-width: 360px;
  margin-top: 30px;
  margin-bottom: 60px;
  text-align: initial;
}
h1 {
  font-size: 2rem;
  font-weight: bold;
  color: #111;
}
h2 {
  margin-top: 0.4em;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.5;
}
.rule {
  margin-bottom: 4px;
  font-size: 12px;
  color: #999;
}
.validationMessage {
  margin-top: 4px;
  font-size: 12px;
  color: $color-red;
  li {
    margin-top: 2px;
  }
}
.formGroup {
  .label {
    margin: 4px;
  }
}
.btn {
  padding: 0.8em 1em;
  font-size: 1.2em;
}
</style>